module.exports = __webpack_public_path__ + "img/step1-c.ea185d41.png";